const runTestWorkflowStepsMap = {
  swab_and_user_identification: 0,
  sensitive_data_compilation: 1,
  payment: 2,
}
export default runTestWorkflowStepsMap
